"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const obstacleInvincibleDuration = 1000;
exports.default = obstacleInvincibleDuration;
